var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"divider-wrapper",style:({ margin: _vm.margin, width: typeof _vm.width === 'string' ? _vm.width : _vm.width + 'px' })},[_c('span',[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }